// export const BASE_URL = "https://api-store.nextlead.ma"
export const BASE_URL = "https://api-manager.topselleraffiliate.ma"
// export const BASE_URL = "http://127.0.0.1:8000"
export const EXTERNAL_BASE_URL = "http://127.0.0.1:8000"


// export const NAME = "nextlead"
export const NAME = "topseller"

